import React from "react";
import { useState } from "react";

export default function TextareaField({ value = "", onChange, onFocus, onBlur, ...props }) {

	const [hasFocus, setHasFocus] = useState(false);

	return <div className="textareaField">
		<textarea
			{...props}
			onFocus={e => {
				setHasFocus(true);
				if (onFocus) onFocus(e);
			}}
			onBlur={e => {
				setHasFocus(false);
				if (onBlur) onBlur(e);
			}}
			value={value}
			onChange={e => {
				if (onChange) {
					onChange(e.target.value);
				}
			}}
		/>
		{Boolean(!hasFocus && !value) && <div 
			className="plus v-middle"
		><span>+</span><span className="featureFont">Add notes</span></div>}
	</div>

}